h3-sampling-workspace-footer{display:block;padding-top:15px;padding-bottom:15px}
/*# sourceMappingURL=sampling-workspace.component.css.map */
